import PropTypes from "prop-types";

import { getPrimaryTag } from "utils/tagUtils";
import { isPresent } from "utils/storeUtils";
import Presenter from "utils/PropTypesPresenter";
import TagPresenter from "presenters/TagPresenter";
import MakeMessagePresenter from "presenters/MakeMessagePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import ProductSharedProperties from "presenters/shared/Product";

export default new Presenter(
  {
    ...ProductSharedProperties,
    castings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        roleRank: PropTypes.number,
        headAsset: PropTypes.string,
        jawSvg: PropTypes.string,
      }),
    ),
    userStatus: PropTypes.string,
    makeMessage: MakeMessagePresenter.shape(),
    tags: PropTypes.string,
    status: PropTypes.string.isRequired,
    templateGroupActive: PropTypes.bool,
  },
  {
    template(m, tg) {
      const template = m?.template;

      if (template && tg?.templates) {
        const filtered = tg.templates?.filter((t) => t.id === template.id);
        if (filtered.length) return filtered[0];
      }

      return template;
    },
    templateGroupId(m, tg) {
      return this.template(m, tg)?.templateGroupSlug;
    },
    templateId(m) {
      return m?.template?.id;
    },
    templateGroupType(m, tg) {
      return TemplateGroupPresenter.templateGroupType(tg);
    },
    webglPositionData(m, tg) {
      return this.template(m, tg)?.webglPositionData;
    },
    webglFeatureVideo(m, tg) {
      return this.template(m, tg)?.webglFeatureVideo;
    },
    positionData(m, tg) {
      return this.template(m, tg)?.positionData;
    },
    manifest(m, tg) {
      return this.template(m, tg)?.manifest;
    },
    isStreamable(tg) {
      return tg?.streamable;
    },
    hasStreamingAssets(m, tg) {
      return this.isStreamable(tg) && isPresent(this.manifest(m, tg)) && isPresent(this.positionData(m, tg));
    },
    isOwner(m) {
      return this.userStatus(m) === "owner";
    },
    isRecipient(m) {
      return this.userStatus(m) === "recipient";
    },
    isDraft(m) {
      return this.status(m) === "draft";
    },
    isLive(m) {
      return this.status(m) === "live";
    },
    notOwnerButtonText(m) {
      const tags = this.tags(m);
      const primaryTag = getPrimaryTag(tags);
      return TagPresenter.notOwnerButtonText(primaryTag);
    },
    notOwnerButtonPath(m, templateGroupId) {
      const tags = this.tags(m);
      const primaryTag = getPrimaryTag(tags);
      return TagPresenter.notOwnerButtonPath(primaryTag, templateGroupId);
    },
    algoliaId(m) {
      return this.templateGroupId(m);
    },
  },
);
